<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">{{ mode === 'edit' ? '修改' : '' }}个人中心</span>
      <el-button v-if="mode === 'detail'" type="primary" @click="mode = 'edit'">修改</el-button>
    </template>
    <el-form
      ref="form"
      label-position="right"
      label-width="auto"
      :model="form"
      :rules="formRules"
      :hide-required-asterisk="mode === 'detail'"
    >
      <el-form-item label="头像" prop="avatar">
        <avatar :username="form.name" :src="form.avatar" :size="40" style="display: inline-flex;vertical-align: top;" />
        <template v-if="mode === 'edit'">
          <el-button class="upload-button" type="primary" @click="$refs.uploadInput.click()">更换头像
          </el-button>
          <div v-show="false">
            <input ref="uploadInput" type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="uploadChange"><input>
            <el-input v-model="form.avatar" />
          </div>
        </template>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">{{ user.userName }}</el-form-item>
      <el-form-item label="姓名" prop="name">
        <template v-if="mode === 'edit'">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </template>
        <template v-else>{{ form.name }}</template>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <template v-if="mode === 'edit'">
          <el-radio-group v-model="form.gender">
            <el-radio :label="2">女</el-radio>
            <el-radio :label="1">男</el-radio>
          </el-radio-group>
        </template>
        <template v-else>{{ form.gender | genderFilter }}</template>
      </el-form-item>
      <el-form-item label="公司" prop="company">
        <template v-if="mode === 'edit'">
          <el-input v-model="form.company" placeholder="请输入公司名称" />
        </template>
        <template v-else>{{ form.company }}</template>
      </el-form-item>
      <el-form-item label="职务" prop="job">
        <template v-if="mode === 'edit'">
          <el-input v-model="form.job" placeholder="请输入职务" />
        </template>
        <template v-else>{{ form.job }}</template>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <template v-if="mode === 'edit'">
          <el-input v-model="form.phone" max-length="11" placeholder="请输入手机号" />
        </template>
        <template v-else>{{ form.phone }}</template>
      </el-form-item>
      <el-form-item v-if="mode === 'edit'">
        <el-button class="save-button" :loading="isLoading" type="primary" @click="save">保存</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { uploadFile, updateUserInfo } from '@/api'
import avatar from 'vue-avatar'

export default {

  components: {
    avatar
  },
  data() {
    return {
      mode: 'detail', // detail edit
      form: {
        avatar: '',
        name: '',
        gender: '',
        company: '',
        job: '',
        phone: ''
      },
      formRules: {
        avatar: [
          {
            required: true,
            message: '请上传头像',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ],
        gender: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ],
        company: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          }
        ],
        job: [
          {
            required: true,
            message: '请输入职务',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            type: 'number',
            message: '请填写正确的手机号码',
            trigger: 'blur'
          }
        ]
      },

      isLoading: false
    }
  },

  computed: {
    ...mapState([
      'user'
    ])
  },

  filters: {
    genderFilter(value) {
      switch (value) {
        case 1:
          return '男'

          break
        case 2:
          return '女'

          break
      }

      return '未知'
    }
  },

  methods: {
    ...mapActions([
      'uploadUserInfo'
    ]),

    /*
     * 初始化表单数据
    */
    intiFormValue() {
      this.form = {
        avatar: this.user.avatarUrl,
        name: this.user.contact,
        gender: this.user.gender,
        company: this.user.companyName,
        job: this.user.resign,
        phone: +this.user.phone
      }
    },

    /*
     * 上传图片
    */
    async uploadChange(e) {
      const fileData = e.target.files[0]

      // 使用formData打包
      const formData = new FormData()
      formData.append('file', fileData)

      try {
        const res = await uploadFile(formData)

        this.form.avatar = res.data.url
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    save() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          this.isLoading = true

          try {
            await updateUserInfo({
              picUrl: this.form.avatar,
              contact: this.form.name,
              gender: this.form.gender,
              companyName: this.form.company,
              resign: this.form.job,
              phone: this.form.phone
            })
            await this.uploadUserInfo()

            this.intiFormValue()
            this.mode = 'detail'
            this.$message.success('保存成功！')
          } catch (error) {
            this.$message.error(error.message)
          }

          this.isLoading = false
        }
      })
    }
  },

  created() {
    this.intiFormValue()
  }
}
</script>

<style lang='scss' scoped>
/deep/ .el-form {
  .el-form-item {
    &:last-child {
      margin: 0;
    }
    .el-form-item__content {
      max-width: 368px;
    }
  }
  .el-form-item__label {
    padding-right: 17px;
    color: #666;
  }
}

.upload-button {
  margin: 0 0 0 30px;
}

.save-button {
  width: 126px;
  height: 40px;
  line-height: 38px;
  padding: 0;
  margin: 10px 0 0;
}
</style>
